<template>
    <div>
        <v-btn class="expansion-btn pa-0 ma-0" text @click="toggleIsExpanded" :aria-expanded="`${isExpanded}`">
            <span class="d-inline-block" :style="expansionIconStyle">></span> {{ title }}
        </v-btn>
        <div v-show="isExpanded">
            <slot/>
        </div>
    </div>
</template>


<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';


@Component
export default class AccessibleExpandible extends Vue {
    @Prop(String) title: string

    isExpanded: boolean = false
    get expansionIconStyle(): string
    {
        if (this.isExpanded)
        {
            return 'transform: rotate(90deg);'
        }
        else 
        {
            return '';
        }
    }

    toggleIsExpanded(){
        this.isExpanded = !this.isExpanded
    }
}
</script>

<style scoped>
.expansion-btn {
    font: inherit;
    font-size: inherit;
    font-style: inherit;
    text-transform: inherit;
}
</style>
